import { KatapultElement, html } from '../../mixins/katapult-element';
import { html as litHtml } from 'lit';
import { KatapultEditorTemplate } from './katapult-editor-template';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';
import { DefaultComputedBindings } from '../../modules/DefaultComputedBindings.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import { PortalStyle } from './katapult-model-editor-style.js';
import { GeneratePushID } from '../../modules/GeneratePushID.js';
import { ToTitleCase } from '../../modules/ToTitleCase.js';
import { KLogic } from '../../modules/KLogic.js';
import { DEFAULT_SCHEMAS } from '../../modules/KLogicSchemas.js';
import '../katapult-firebase-worker/katapult-firebase-worker.js';
import '../katapult-elements/katapult-button.js';
import '../job-chooser/job-chooser.js';
import { Download } from '../../modules/Download.js';
import { uuidv4 } from '../../modules/browserUUIDv4.js';

class KatapultConfigurableExportEditor extends mixinBehaviors(DefaultComputedBindings, KatapultEditorTemplate) {
  static get template() {
    return html`
      ${super.style}
      <!-- TODO - This is bad naming, figure out better solution -->
      ${PortalStyle}
      <style>
        [hidden] {
          display: none;
        }
        .body {
          margin-left: 48px;
        }
        paper-tabs {
          --paper-tabs-selection-bar-color: var(--secondary-color);
          --paper-tab-ink: var(--secondary-color);
        }
        paper-tab {
          --paper-tab: {
            font-size: 12pt;
            font-weight: normal;
          };
          --paper-tab-content-focused: {
            font-weight: normal;
          };
        }

        paper-header-content {
          background-color: white;
          color: var(--paper-grey-800);
        }
        paper-header-content paper-input {
          text-transform: none;
        }

        [drag-handle]:hover {
          cursor: move;
        }

        paper-tabs {
          --paper-tabs-content: {
            display: flex;
            min-width: 100%;
          };
        }

        .dialog-option {
          min-width: 5.14em;
        }

        .manage-item-button {
          --paper-menu-button-content: {
            border-radius: 16px;
            white-space: nowrap;
          };
        }
        [slot='content'] {
          box-shadow: inset 0px 0px 8px rgba(0, 0, 0, 0.06);
        }
        paper-input {
          --paper-input-container-disabled: {
            opacity: 0.6;
          };
        }
      </style>
      <katapult-firebase-worker
        path="photoheight/jobs/[[_itemData.preview_job]]"
        data="{{previewJobData}}"
        disabled="[[disabled]]"
      ></katapult-firebase-worker>

      <excel-exports id="excelExports" user-group="[[userGroup]]" job-creator="[[modelSpaceDetails.$key]]"></excel-exports>

      <template is="dom-repeat" items="[[steps]]" as="step">
        <katapult-editor-step
          step$="[[step.id]]"
          creating-item="[[creatingItem]]"
          active="[[step.active]]"
          index="[[step.index]]"
          current-index="[[currentIndex]]"
          title="[[step.title]]"
        >
          <!-- File Name -->
          <template is="dom-if" if="[[equal(step.id, 'file_name')]]">
            <material-icon icon="help" slot="header">
              <katapult-tooltip
                >The name of the file to be exported. Optional: configure custom logic to make the file name dynamic.</katapult-tooltip
              >
            </material-icon>
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <paper-input
                    id="fileName"
                    label="File Name"
                    hidden="[[!hideLogicInput(_itemData.file_name)]]"
                    value="{{_itemData.file_name}}"
                    no-label-float
                  ></paper-input>
                  <paper-input
                    id="logicFileName"
                    hidden="[[hideLogicInput(_itemData.file_name)]]"
                    label="File Name"
                    disabled
                    no-label-float
                  ></paper-input>
                </paper-cell>
              </paper-row>
            </paper-table>
            <paper-cell slot="body">
              <katapult-button
                icon="functions"
                iconOnly
                color="{{getKLogicButtonColor(_itemData.file_name)}}"
                on-click="openLogicEditor"
                property="file_name"
              >
                <katapult-tooltip>Custom Logic</katapult-tooltip>
              </katapult-button>
            </paper-cell>
          </template>

          <!-- Export File Type -->
          <template is="dom-if" if="[[equal(step.id, 'export_file_type')]]">
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <katapult-drop-down
                    value="{{_itemData.export_file_type}}"
                    items="[[exportTypeOptions]]"
                    label-path="label"
                    value-path="type"
                    no-label-float
                  ></katapult-drop-down>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>
          <!-- Export Template -->
          <template is="dom-if" if="[[equal(step.id, 'export_template')]]">
            <div slot="body" style="display: flex: flex-direction: column;">
              <template is="dom-if" if="[[_itemData.export_template_name]]">
                <paper-table light-grey style="min-width: 400px; margin-bottom:20px;" rounded outline slot="body">
                  <paper-row input>
                    <paper-cell>[[_itemData.export_template_name]]</paper-cell>
                    <paper-cell icon-button>
                      <katapult-button
                        iconOnly
                        noBorder
                        loading="[[loadingTemplateFromStorage]]"
                        icon="download"
                        on-click="downloadTemplate"
                      ></katapult-button>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </template>
              <div style="display: flex; gap: 1em;">
                <input id="input" type="file" accept=".xlsx" style="display: none;" on-change="loadTemplate" />
                <katapult-button icon="upload" callback="promptLoadTemplate" disabled="[[!fullyEditable]]"
                  >Choose a Template</katapult-button
                >
                <template is="dom-if" if="[[_itemData.export_template_name]]" restamp>
                  <katapult-button icon="delete" callback="removeTemplate" disabled="[[!fullyEditable]]">Remove Template</katapult-button>
                </template>
              </div>
            </div>
            <katapult-button style="margin-left: 16px; min-width: 5.14em;" slot="current-step-body" on-click="nextStep"
              >Skip</katapult-button
            >
          </template>

          <!-- Preview Job Id -->
          <template is="dom-if" if="[[equal(step.id, 'preview_job')]]">
            <paper-table light-grey style="width: 400px;" rounded outline slot="body">
              <paper-row input>
                <paper-cell>
                  <job-chooser
                    alphabetical="[[orderJobsAlphabetically]]"
                    style="--paper-input-container-underline-display: block; background-color: unset"
                    selected="{{_itemData.preview_job}}"
                    model-options="[[modelOptions]]"
                    user-group="[[userGroup]]"
                    label="Choose a preview job"
                    no-create-new-job
                    firebase-disabled="[[!confirmDialogOpened]]"
                  ></job-chooser>
                </paper-cell>
              </paper-row>
            </paper-table>
          </template>

          <!-- Export Availability -->
          <template is="dom-if" if="[[equal(step.id, 'export_availability')]]">
            <paper-cell slot="header">
              <material-icon icon="help">
                <katapult-tooltip
                  >When checked, any user with access to the job can download. When unchecked, only users in your company can download.
                </katapult-tooltip>
              </material-icon>
              <paper-checkbox style="padding-left: 30px" checked="{{_itemData.export_availability}}"></paper-checkbox>
            </paper-cell>
          </template>

          <!-- Sheets -->
          <template is="dom-if" if="[[equal(step.id, 'sheets')]]">
            <!-- Table -->
            <paper-table rounded outline slot="body" grow overflow-hidden>
              <paper-table-scroll data-path="_itemData.sheets" on-sort-changed="orderedItemsArraySortChanged">
                <!-- Header -->
                <paper-row grey short slot="before">
                  <paper-cell icon>
                    <material-icon icon="swap_vert"></material-icon>
                  </paper-cell>
                  <paper-cell>Sheet</paper-cell>
                  <paper-cell icon>
                    <material-icon icon="unfold_more"></material-icon>
                  </paper-cell>
                  <paper-cell icon></paper-cell>
                </paper-row>
                <!-- Body -->
                <template is="dom-repeat" items="[[getOrderedItemsArray(_itemData.sheets.*)]]" mutable-data as="sheet">
                  <paper-header-content
                    id$="sheet_[[sheet.$key]]"
                    data-path="_itemData.sheets.$(model.sheet.$key)"
                    on-opened-changed="updateProperty"
                    on-render-changed="updateProperty"
                    slot="sortable"
                    opened="[[sheet.$opened]]"
                    divider
                    no-click-row
                  >
                    <paper-cell slot="header" icon drag-handle>[[add(index, 1)]]</paper-cell>
                    <paper-cell
                      id="sheetNameHeader"
                      hidden="[[!hideLogicInput(sheet.sheet_name)]]"
                      slot="header"
                      class="status-name"
                      on-click="togglePaperHeaderRow"
                      >[[sheet.sheet_name]]</paper-cell
                    >
                    <paper-cell
                      id="logicSheetNameHeader"
                      hidden="[[hideLogicInput(sheet.sheet_name)]]"
                      slot="header"
                      class="status-name"
                    ></paper-cell>
                    <paper-cell slot="header-end" icon-button>
                      <paper-menu-button class="manage-item-button" horizontal-align="right" vertical-align="top" vertical-offset="48">
                        <katapult-button iconOnly noBorder slot="dropdown-trigger" icon-button icon="more_vert"></katapult-button>
                        <div slot="dropdown-content">
                          <div flex align-center style="padding: 12px; gap: 8px; position: relative;" data-action="COPY" on-click="">
                            <paper-ripple></paper-ripple>
                            <material-icon icon="content_copy"></material-icon>
                            <div>Copy Sheet</div>
                          </div>
                          <div flex align-center style="padding: 12px; gap: 8px; position: relative;" data-action="PASTE" on-click="">
                            <paper-ripple></paper-ripple>
                            <material-icon icon="content_paste"></material-icon>
                            <div>Paste Sheet</div>
                          </div>
                          <div flex align-center style="padding: 12px; gap: 8px; position: relative;" on-click="deleteItem">
                            <paper-ripple></paper-ripple>
                            <material-icon icon="delete"></material-icon>
                            <div>Delete Sheet</div>
                          </div>
                        </div>
                      </paper-menu-button>
                    </paper-cell>
                    <div slot="content">
                      <paper-row input>
                        <paper-cell shrink>Sheet Name</paper-cell>
                        <paper-cell icon>
                          <material-icon icon="help">
                            <katapult-tooltip
                              >The name of the sheet inside the export. Optional: configure custom logic to make the sheet name
                              dynamic.</katapult-tooltip
                            >
                          </material-icon>
                        </paper-cell>
                        <paper-cell shrink style="min-width: 30%">
                          <paper-input
                            id="sheetNameInput"
                            hidden="[[!hideLogicInput(sheet.sheet_name)]]"
                            on-value-changed="updateProperty"
                            data-path="_itemData.sheets.$(model.sheet.$key).sheet_name"
                            value="{{sheet.sheet_name}}"
                            no-label-float
                            underline
                          ></paper-input>
                          <paper-input
                            id="logicSheetInput"
                            hidden="[[hideLogicInput(sheet.sheet_name)]]"
                            no-label-float
                            disabled
                            underline
                          ></paper-input>
                        </paper-cell>
                        <paper-cell shrink>
                          <katapult-button
                            icon="functions"
                            iconOnly
                            color="{{getKLogicButtonColor(sheet.sheet_name)}}"
                            on-click="openLogicEditor"
                            property="sheet_name"
                          >
                            <katapult-tooltip>Custom Logic</katapult-tooltip>
                          </katapult-button>
                        </paper-cell>
                      </paper-row>
                      <paper-row input>
                        <paper-cell shrink>Sheet Display Logic (optional)</paper-cell>
                        <paper-cell icon>
                          <material-icon icon="help">
                            <katapult-tooltip
                              >Custom logic returns false if this sheet should be excluded from the export.</katapult-tooltip
                            >
                          </material-icon>
                        </paper-cell>
                        <paper-cell shrink>
                          <katapult-button
                            icon="functions"
                            iconOnly
                            color="{{getKLogicButtonColor(sheet.sheet_display_logic)}}"
                            on-click="openLogicEditor"
                            property="sheet_display_logic"
                          >
                            <katapult-tooltip>Custom Logic</katapult-tooltip>
                          </katapult-button>
                        </paper-cell>
                      </paper-row>
                      <!-- TODO, finalize CSS -->
                      <paper-row expand>
                        <paper-cell shrink>Groups</paper-cell>
                        <paper-cell>
                          <paper-table rounded outline grow overflow-hidden>
                            <!-- Header -->
                            <paper-row grey short>
                              <paper-cell>Group</paper-cell>
                              <paper-cell icon>
                                <material-icon icon="unfold_more"></material-icon>
                              </paper-cell>
                              <paper-cell icon></paper-cell>
                            </paper-row>
                            <template is="dom-repeat" items="[[getOrderedItemsArray(sheet.groups)]]" mutable-data as="group">
                              <paper-header-content
                                id$="group_[[group.$key]]"
                                data-path="_itemData.sheets.$(model.parentModel.sheet.$key).groups.$(model.group.$key)"
                                on-opened-changed="updateProperty"
                                opened="[[group.$opened]]"
                                divider
                                no-click-row
                              >
                                <paper-cell slot="header" class="status-name" on-click="togglePaperHeaderRow"
                                  >[[group.group_name]]</paper-cell
                                >
                                <paper-cell slot="header-end" icon-button>
                                  <paper-menu-button
                                    class="manage-item-button"
                                    horizontal-align="right"
                                    vertical-align="top"
                                    vertical-offset="48"
                                  >
                                    <katapult-button
                                      iconOnly
                                      noBorder
                                      slot="dropdown-trigger"
                                      icon-button
                                      icon="more_vert"
                                    ></katapult-button>
                                    <div slot="dropdown-content">
                                      <div flex align-center style="padding: 12px; gap: 8px; position: relative;" on-click="deleteItem">
                                        <paper-ripple></paper-ripple>
                                        <material-icon icon="delete"></material-icon>
                                        <div>Delete Group</div>
                                      </div>
                                    </div>
                                  </paper-menu-button>
                                </paper-cell>
                                <div slot="content">
                                  <paper-row input>
                                    <paper-cell shrink>Group Name</paper-cell>
                                    <paper-cell shrink style="min-width: 30%">
                                      <paper-input
                                        no-label-float
                                        underline
                                        value="[[group.group_name]]"
                                        on-value-changed="updateProperty"
                                        data-path="_itemData.sheets.$(model.parentModel.sheet.$key).groups.$(model.group.$key).group_name"
                                      ></paper-input>
                                    </paper-cell>
                                  </paper-row>
                                  <paper-row input>
                                    <paper-cell shrink>Group Filtering Logic (optional)</paper-cell>
                                    <paper-cell icon>
                                      <material-icon icon="help">
                                        <katapult-tooltip>Custom logic that filters data that all nested data will use</katapult-tooltip>
                                      </material-icon>
                                    </paper-cell>
                                    <paper-cell shrink>
                                      <katapult-button
                                        icon="functions"
                                        iconOnly
                                        color="{{getKLogicButtonColor(group.group_filtering_logic)}}"
                                        on-click="openLogicEditor"
                                        property="group_filtering_logic"
                                      >
                                        <katapult-tooltip>Custom Logic</katapult-tooltip>
                                      </katapult-button>
                                    </paper-cell>
                                  </paper-row>
                                  <paper-row expand>
                                    <paper-cell shrink>Data</paper-cell>
                                    <paper-cell icon>
                                      <material-icon icon="help">
                                        <katapult-tooltip style="white-space: pre-line;">
                                          Data determine WHAT is exported, along with WHERE that data is exported. Each data point acts upon
                                          the dataset specified by the Group Filtering Logic. Location: Cell reference to put the data in.
                                          Output: - Cell : Put entire result into one single cell. - Row : If the result is a list, put the
                                          first result into Location and subsequent results along the same row, moving right. - Column : If
                                          the result is a list, put the first result into Location and subsequent results in the same
                                          column, moving downwards. Logic: Custom Logic that determines the data to export.
                                          <!-- ending katapult-toolip tag should be kept on the same line as the last line of text to ensure proper line wrapping in the tooltip -->
                                          Result: Preview of output using the specified Preview Job.</katapult-tooltip
                                        >
                                      </material-icon>
                                    </paper-cell>
                                    <paper-cell>
                                      <paper-table rounded outline grow overflow-hidden dividers>
                                        <paper-table-scroll
                                          data-path="_itemData.sheets.$(model.parentModel.sheet.$key).groups.$(model.group.$key).data"
                                          on-sort-changed="orderedItemsArraySortChanged"
                                        >
                                          <paper-row grey short slot="before">
                                            <paper-cell icon>
                                              <material-icon icon="swap_vert"></material-icon>
                                            </paper-cell>
                                            <paper-cell style="flex-grow: 2">Location</paper-cell>
                                            <paper-cell style="flex-grow: 1">Output</paper-cell>
                                            <paper-cell center style="flex-grow: 1">Logic</paper-cell>
                                            <paper-cell style="flex-grow: 6">Result</paper-cell>
                                            <paper-cell shrink style="width: 80px"></paper-cell>
                                          </paper-row>
                                          <template is="dom-repeat" items="[[getOrderedItemsArray(group.data)]]" mutable-data as="data">
                                            <paper-row id$="row_{{data.$key}}" tall white slot="sortable">
                                              <paper-cell icon drag-handle>[[add(index, 1)]]</paper-cell>
                                              <paper-cell style="flex-grow: 2">
                                                <paper-input
                                                  class="locationInput"
                                                  no-label-float
                                                  underline
                                                  label="Location"
                                                  value="{{data.location}}"
                                                  on-value-changed="updateProperty"
                                                  data-path="_itemData.sheets.$(model.parentModel.parentModel.sheet.$key).groups.$(model.parentModel.group.$key).data.$(model.data.$key).location"
                                                ></paper-input>
                                              </paper-cell>
                                              <paper-cell style="flex-grow: 1">
                                                <katapult-drop-down
                                                  no-label-float
                                                  items="[[outputFormatting]]"
                                                  value="{{data.output}}"
                                                  on-value-changed="updateProperty"
                                                  data-path="_itemData.sheets.$(model.parentModel.parentModel.sheet.$key).groups.$(model.parentModel.group.$key).data.$(model.data.$key).output"
                                                ></katapult-drop-down>
                                              </paper-cell>
                                              <paper-cell center style="flex-grow: 1">
                                                <katapult-button
                                                  icon="functions"
                                                  iconOnly
                                                  size="small"
                                                  color="{{getKLogicButtonColor(data.logic)}}"
                                                  on-click="openLogicEditor"
                                                  property="logic"
                                                >
                                                  <katapult-tooltip>Custom Logic</katapult-tooltip>
                                                </katapult-button>
                                              </paper-cell>
                                              <paper-cell
                                                style="flex-grow: 6; overflow:hidden; text-wrap:nowrap; opacity:0.6;"
                                                id="dataResult"
                                              ></paper-cell>
                                              <paper-cell shrink>
                                                <paper-menu-button
                                                  class="manage-item-button"
                                                  horizontal-align="right"
                                                  vertical-align="top"
                                                  vertical-offset="48"
                                                >
                                                  <katapult-button
                                                    iconOnly
                                                    noBorder
                                                    slot="dropdown-trigger"
                                                    icon-button
                                                    icon="more_vert"
                                                  ></katapult-button>
                                                  <div slot="dropdown-content">
                                                    <div
                                                      flex
                                                      align-center
                                                      style="padding: 12px; gap: 8px; position: relative;"
                                                      on-click="deleteItem"
                                                    >
                                                      <paper-ripple></paper-ripple>
                                                      <material-icon icon="delete"></material-icon>
                                                      <div>Delete Data</div>
                                                    </div>
                                                  </div>
                                                </paper-menu-button>
                                              </paper-cell>
                                            </paper-row>
                                          </template>
                                          <paper-row class="addButton" light-grey short slot="after">
                                            <paper-cell ripple id="addData" on-click="clickHandler">
                                              <material-icon icon="playlist_add"></material-icon>
                                              <div>Add Data</div>
                                            </paper-cell>
                                          </paper-row>
                                        </paper-table-scroll>
                                      </paper-table>
                                    </paper-cell>
                                  </paper-row>
                                </div>
                              </paper-header-content>
                            </template>
                            <paper-row class="addButton" light-grey short>
                              <paper-cell ripple id="addGroup" on-click="clickHandler">
                                <material-icon icon="playlist_add"></material-icon>
                                <div>Add Group</div>
                              </paper-cell>
                            </paper-row>
                          </paper-table>
                        </paper-cell>
                      </paper-row>
                    </div>
                  </paper-header-content>
                </template>
                <!-- Add Button -->
                <paper-row class="addButton" light-grey short slot="after">
                  <paper-cell ripple on-click="addSheet">
                    <material-icon icon="playlist_add"></material-icon>
                    <div>Add Sheet</div>
                  </paper-cell>
                </paper-row>
              </paper-table-scroll>
            </paper-table>
          </template>
        </katapult-editor-step>
      </template>
      ${super.createItemContainer}
    `;
  }

  static get properties() {
    return {
      exportTypeOptions: {
        type: Array,
        value: () => [
          {
            label: '.xlsx',
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
          {
            label: '.csv',
            type: 'text/csv'
          }
          // 'Google Sheets'
        ]
      },
      outputFormatting: {
        type: Array,
        value: () => ['Cell', 'Row', 'Column']
      },
      skipCreationSteps: {
        type: Boolean,
        value: true
      },
      exportDataHasLoaded: {
        type: Boolean,
        value: false
      },
      computeData: {
        type: Object
      }
    };
  }

  static get observers() {
    return [
      'creatingNewExport(creatingItem, _itemData)',
      'exportDataLoaded(_itemData)',
      'updateComputeData(previewJobData)',
      'calculateDataPointResults(exportDataHasLoaded, computeData)',
      'calculateFileNameResult(exportDataHasLoaded, computeData)',
      'calculateSheetNameResults(exportDataHasLoaded, computeData)'
    ];
  }

  ready() {
    super.ready();

    this.keyMatchLabel = true;

    // An ordered list of all possible steps.
    // TODO - Ensure all initial creation steps are visible when creating new export
    this.setSteps([
      {
        id: 'file_name',
        title: 'File Name'
      },
      {
        id: 'export_file_type',
        title: 'Export File Type'
      },
      {
        id: 'export_template',
        title: 'Export Template',
        if: () => this.get('_itemData.export_file_type') == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      {
        id: 'preview_job',
        title: 'Preview Job'
      },
      {
        id: 'export_availability',
        title: 'Available to All Users'
      },
      {
        id: 'sheets',
        title: 'Sheets'
      }
    ]);
  }

  creatingNewExport(creatingItem, itemData) {
    // create a new sheet when we are making a new export from scratch
    if (creatingItem && itemData) this.addSheet();
  }

  // handle all click events for add/deleting of sheets/groups/data
  async keySearch(e) {
    let model = e.model || e.parentEvent.model;

    let search = function (model, searchKey) {
      // check to see if this key exists in this model
      if (model[searchKey]) return model[searchKey].$key;
      // return null if we can't find a parentModel
      if (!model.parentModel) return null;
      // if we haven't found our key, search the parentModel
      else return search(model.parentModel, searchKey);
    };

    let dataKeys = {};
    ['sheet', 'group', 'data'].forEach((x) => (dataKeys[x] = search(model, x)));
    return dataKeys;
  }

  togglePaperHeaderRow(e) {
    let paperHeaderContent = e.currentTarget.parentElement;
    paperHeaderContent.toggle();
  }

  // handle all click events for add/deleting of sheets/groups/data
  clickHandler(e, detail) {
    let model = e.model || e.parentEvent.model;
    let target = e.currentTarget;
    let func = detail.id || target.id;

    let search = function (model, searchKey) {
      // check to see if this key exists in this model
      if (model[searchKey]) return model[searchKey].$key;
      // return null if we can't find a parentModel
      if (!model.parentModel) return null;
      // if we haven't found our key, search the parentModel
      else return search(model.parentModel, searchKey);
    };

    let dataKeys = ['sheet', 'group', 'data'].map((x) => search(model, x));
    this[func].apply(this, dataKeys);
  }

  addSheet() {
    // create new blank sheet
    let newSheetKey = GeneratePushID();
    const order = Object.values(this._itemData.sheets ?? {}).length;
    const path = `_itemData.sheets.${newSheetKey}`;
    this.updateProperty(new CustomEvent('add-item', { detail: { path, value: { order, sheet_name: `Sheet ${order + 1}` } } }));

    // focus and open the newly created sheet, intentional design choice
    setTimeout(() => {
      let sheetElement = this.shadowRoot.querySelector(`#sheet_${newSheetKey}`);
      sheetElement.toggle();
    }, 50);

    // scroll to the bottom of the element
    this.scrollTop = this.scrollHeight - this.clientHeight;

    // add new group and data to this blank sheet
    this.addGroup(newSheetKey);
  }

  addGroup(sheetKey) {
    if (sheetKey) {
      // create new blank group
      let newGroupKey = GeneratePushID();
      const order = Object.values(this._itemData?.sheets?.[sheetKey]?.groups ?? {}).length;
      const path = `_itemData.sheets.${sheetKey}.groups.${newGroupKey}`;
      this.updateProperty(new CustomEvent('add-item', { detail: { path, value: { group_name: `${order + 1}` } } }));

      // focus and open the newly created sheet, intentional design choice
      setTimeout(() => {
        let groupElement = this.shadowRoot.querySelector(`#group_${newGroupKey}`);
        groupElement.toggle();
      }, 50);

      // add new data to this blank group
      this.addData(sheetKey, newGroupKey);
    }
  }

  addData(sheetKey, groupKey) {
    if (sheetKey && groupKey) {
      const order = Object.values(this._itemData?.sheets?.[sheetKey]?.groups?.[groupKey]?.data ?? {}).length;
      const path = `_itemData.sheets.${sheetKey}.groups.${groupKey}.data.${GeneratePushID()}`;
      this.updateProperty(new CustomEvent('add-item', { detail: { path, value: { order, output: `Cell` } } }));
    }
  }

  deleteSheet(sheetKey) {
    if (sheetKey) {
      const path = `_itemData.sheets.${sheetKey}`;
      this.updateProperty(new CustomEvent('delete-item', { detail: { path, value: null } }));

      // delete from the local copy of data, otherwise we just set that key to be null which throws off ordering
      delete this._itemData.sheets[sheetKey];

      // update the order of the sheets after we delete a sheet
      this.updateSheetOrder();
    }
  }

  deleteGroup(sheetKey, groupKey) {
    if (sheetKey && groupKey) {
      const path = `_itemData.sheets.${sheetKey}.groups.${groupKey}`;
      this.updateProperty(new CustomEvent('delete-item', { detail: { path, value: null } }));

      // delete from the local copy of data, otherwise we just set that key to be null which throws off ordering
      delete this._itemData.sheets[sheetKey].groups[groupKey];
    }
  }

  deleteData(sheetKey, groupKey, dataKey) {
    if (sheetKey && groupKey && dataKey) {
      const path = `_itemData.sheets.${sheetKey}.groups.${groupKey}.data.${dataKey}`;
      this.updateProperty(new CustomEvent('delete-item', { detail: { path, value: null } }));

      // delete from the local copy of data, otherwise we just set that key to be null which throws off ordering
      delete this._itemData.sheets[sheetKey].groups[groupKey].data[dataKey];

      // update the order of the data after we delete data
      this.updateDataOrder(sheetKey, groupKey);
    }
  }

  async deleteItem(e) {
    // close paper menu button
    e.currentTarget.closest('paper-menu-button').close();
    await this.keySearch(e).then((keys) => {
      // calc dynamic dialog content
      let prompt = 'Are you sure you want to delete this sheet?';
      let confirmDeleteButton = 'Confirm Delete Sheet';
      let func = 'deleteSheet';

      if (keys.group) {
        prompt = 'Are you sure you want to delete this group?';
        confirmDeleteButton = 'Confirm Delete Group';
        func = 'deleteGroup';
      }
      if (keys.data) {
        prompt = 'Are you sure you want to delete this data?';
        confirmDeleteButton = 'Confirm Delete Data';
        func = 'deleteData';
      }

      KatapultDialog.confirm(prompt, confirmDeleteButton).confirmed.then((res) => {
        if (res) this[func](keys.sheet, keys.group, keys.data);
      });
    });
  }

  async addDataOrGroup(e) {
    // close paper menu button
    e.currentTarget.closest('paper-menu-button').close();
    await this.keySearch(e).then((keys) =>
      keys.data ? this.addData(keys.sheet, keys.group, keys.data) : this.addGroup(keys.sheet, keys.group)
    );
  }

  updateSheetOrder() {
    let sheets = JSON.parse(JSON.stringify(this._itemData.sheets));
    let sortedSheets = Object.keys(sheets).sort((a, b) => sheets[a].order - sheets[b].order);
    for (let i = 0; i < sortedSheets.length; i++) {
      let path = `_itemData.sheets.${sortedSheets[i]}.order`;
      this.updateProperty(new CustomEvent('sort-changed', { detail: { path, value: i++ } }));
    }
  }

  // this method reorders the data that is in a group, given the sheetKey and groupKey
  updateDataOrder(sheetKey, groupKey) {
    let data = this._itemData.sheets[sheetKey].groups[groupKey].data;
    let counter = 0;
    for (let dataKey in data) {
      let path = `_itemData.sheets.${sheetKey}.groups.${groupKey}.data.${dataKey}.order`;
      this.updateProperty(new CustomEvent('sort-changed', { detail: { path, value: counter++ } }));
    }
  }

  async buildDataPath(e) {
    return await this.keySearch(e).then((keys) => {
      if (keys.data) return `_itemData.sheets.${keys.sheet}.groups.${keys.group}.data.${keys.data}`;
      else if (keys.group) return `_itemData.sheets.${keys.sheet}.groups.${keys.group}`;
      else if (keys.sheet) return `_itemData.sheets.${keys.sheet}`;
      else return '_itemData';
    });
  }
  hideLogicInput(data) {
    if (typeof data == 'string') return true;
    else return false;
  }

  async openLogicEditor(e) {
    let model = e.model;
    let target = e.currentTarget;
    let keys = await this.keySearch(e);
    let property = target.getAttribute('property');
    // path to the data that we are going to be editing
    let dataPath = await this.buildDataPath(e);
    // data that exists at the data path
    let existingEditorData = JSON.parse(JSON.stringify(this.get(`${dataPath}.${property}`) || {}));

    // configure proper title to display
    let title = ToTitleCase(property);
    // determine if we are editing a data/group/sheet and append an identifying string to the title
    let editingType = keys.data ? 'Data Point' : keys.group ? 'Group' : keys.sheet ? 'Sheet' : null;
    if (editingType) title = `${title} for ${editingType} ${model.index + 1}`;

    const commonData = {
      job: DEFAULT_SCHEMAS.JOB,
      connection_lookup: DEFAULT_SCHEMAS.CONNECTION_LOOKUP,
      marker_lookup: DEFAULT_SCHEMAS.MARKER_LOOKUP
    };

    const dialog = KatapultDialog.open({
      dialog: {
        title,
        draggable: true
      },
      template: () => litHtml`
      <div style="color:var(--paper-red-500); padding: 5px; text-align:center; font-weight: 500">${
        this.previewJobData ? null : 'WARNING: No preview job selected'
      }</div>
      <div>
        <k-logic-editor block="${existingEditorData}" expand-editor></k-logic-editor>
      </div>
      <div slot="buttons">
        <katapult-button dialog-dismiss>Cancel</katapult-button>
        <katapult-button id="confirm" color="var(--secondary-color)" dialog-confirm>Save</katapult-button>
      </div>
      `
    });
    // Get the k-logic-editor
    const editor = dialog.querySelector('k-logic-editor');
    // set existing data on the editor so that when we open the dialog the editor has the right data
    editor.block = existingEditorData;

    // set the schema for the k-logic editor
    editor.schema = commonData;

    await dialog.openStart;
    // Get the confirm button.
    const confirmButton = dialog.querySelector('#confirm');
    // get data from the editor
    confirmButton.addEventListener('click', async () => {
      // grab the current data from the editor
      // if we have data in our klogic editor
      if (!!editor.block) {
        // grab all the relevant data keys, and construct our data path with those keys
        this.updateProperty(new CustomEvent('update-item', { detail: { path: `${dataPath}.${property}`, value: editor.block } }));
        if (property == 'logic') {
          this.calculateDataPointResults({
            logic: editor.block,
            keys
          });
        } else if (property == 'sheet_name') {
          this.calculateSheetNameResults({
            logic: editor.block,
            keys
          });
        } else if (property == 'file_name') {
          this.calculateFileNameResult(editor.block);
        }
        // something that lets us know klogic has to run here
        dialog.close();
      }
      // the k-logic editor is empty, in otherwords, null
      else {
        if (property == 'file_name')
          this.updateProperty(new CustomEvent('update-item', { detail: { path: `${dataPath}.${property}`, value: 'File Name' } }));
        else if (property == 'sheet_name')
          this.updateProperty(new CustomEvent('update-item', { detail: { path: `${dataPath}.${property}`, value: 'Sheet Name' } }));
        else this.updateProperty(new CustomEvent('update-item', { detail: { path: `${dataPath}.${property}`, value: null } }));
      }
    });
  }

  getKLogicButtonColor(data) {
    if (typeof data === 'object' && !Array.isArray(data) && data !== null) return 'var(--secondary-color)';
    else return 'white';
  }

  exportDataLoaded(_itemData) {
    if (_itemData && !this.exportDataHasLoaded) this.set('exportDataHasLoaded', true);
  }

  updateComputeData(previewJobData) {
    this.set('computeData', {
      job: previewJobData
    });
  }

  calculateDataPointResults(logicData) {
    // we need data from the preview job to load any results
    if (this.previewJobData) {
      // this will be true when the page loads, update all k-logic
      if (typeof logicData == 'boolean' && this.exportDataHasLoaded) {
        // tiny set timeout to allow the DOM to render
        setTimeout(() => {
          let sheets = this._itemData.sheets;
          for (let sheetKey in sheets) {
            let sheet = sheets[sheetKey];
            for (let groupKey in sheet.groups) {
              let group = sheet.groups[groupKey];
              // logic that will be used to filter the job data for use in this group
              let groupFilteringLogic = group.group_filtering_logic;
              let filteredData;
              // filtered data to pass to the individual data points, if applicable
              if (groupFilteringLogic) filteredData = KLogic.compute(groupFilteringLogic, this.computeData);
              for (let dataKey in group.data) {
                let logic = group.data[dataKey].logic;
                if (logic) {
                  // results of our k-logic computation
                  let results = KLogic.compute(logic, filteredData ? filteredData : this.computeData);
                  this.updateDataLogicResults(results, dataKey);
                }
              }
            }
          }
        }, 1);
      }
      // this will be true when we have updated an individual data point's k-logic
      else if (typeof logicData === 'object' && !Array.isArray(logicData) && logicData !== null) {
        let groupFilteringLogic = this._itemData.sheets[logicData?.keys.sheet].groups[logicData?.keys.group].group_filtering_logic;
        let filteredData;
        // filtered data to pass to the individual data points, if applicable
        if (groupFilteringLogic) filteredData = KLogic.compute(groupFilteringLogic, this.computeData);
        // results of our k-logic computation
        let results = KLogic.compute(logicData?.logic, filteredData ? filteredData : this.computeData);
        this.updateDataLogicResults(results, logicData?.keys.data);
      }
    }
  }

  calculateFileNameResult(logicData) {
    // need preview job data to use logic
    if (this.previewJobData) {
      // this will be true when the page loads
      if (typeof logicData == 'boolean' && this.exportDataHasLoaded) {
        // only compute if the stored file_name data is an object, denoting that it's k-logic
        if (typeof this._itemData.file_name === 'object' && !Array.isArray(this._itemData.file_name) && this._itemData.file_name !== null) {
          let results = KLogic.compute(this._itemData.file_name, this.computeData);
          let fileNameInput = this.shadowRoot.querySelector(`#logicFileName`);
          fileNameInput.value = results;
        }
      }
      // this will be true when we manually update the file name to use k-logic
      else if (typeof logicData === 'object' && !Array.isArray(logicData) && logicData !== null) {
        let results = KLogic.compute(logicData, this.computeData);
        let fileNameInput = this.shadowRoot.querySelector(`#logicFileName`);
        fileNameInput.value = results;
      }
    }
  }

  calculateSheetNameResults(logicData) {
    // need preview job data to use logic
    if (this.previewJobData) {
      // this will be true when the page loads
      if (typeof logicData == 'boolean' && this.exportDataHasLoaded) {
        // only compute if the stored sheet_name data is an object, denoting that it's k-logic
        setTimeout(() => {
          let sheets = this._itemData.sheets;
          for (let sheetKey in sheets) {
            let sheet = sheets[sheetKey];
            if (typeof sheet.sheet_name === 'object' && !Array.isArray(sheet.sheet_name) && sheet.sheet_name !== null) {
              let results = KLogic.compute(sheet.sheet_name, this.computeData);
              let sheetElement = this.shadowRoot.querySelector(`#sheet_${sheetKey}`);
              let logicSheetinput = sheetElement.querySelector('#logicSheetInput');

              let sheetPaperHeader = sheetElement.querySelector('#logicSheetNameHeader');
              sheetPaperHeader.innerHTML = results;
              logicSheetinput.value = results;
            }
          }
        }, 1);
      }
      // this will be true when we manually update the file name to use k-logic
      else if (typeof logicData === 'object' && !Array.isArray(logicData) && logicData !== null) {
        let results = KLogic.compute(logicData.logic, this.computeData);
        let sheetElement = this.shadowRoot.querySelector(`#sheet_${logicData.keys.sheet}`);
        let logicSheetinput = sheetElement.querySelector('#logicSheetInput');
        let sheetPaperHeader = sheetElement.querySelector('#logicSheetNameHeader');
        sheetPaperHeader.innerHTML = results;
        logicSheetinput.value = results;
      }
    }
  }

  updateDataLogicResults(results, dataKey) {
    // find the row that we pulled the logic from
    let dataRow = this.shadowRoot.querySelector(`#row_${dataKey}`);
    if (dataRow) {
      // find the correct input to display this result
      let input = dataRow.querySelector('#dataResult');
      // visually update the input's value property
      if (Array.isArray(results)) input.innerHTML = results.join(', ');
      else input.innerHTML = results;
    }
  }

  validateCellReference(coordinate) {
    if (typeof coordinate != 'string' || !coordinate.length) return false;
    var startIndex = coordinate.search(/[\d+]/);

    // test column
    var column = coordinate.substring(0, startIndex).toUpperCase();
    if (column < 'A' || column >= 'XFD') return false;

    // test row
    let row = coordinate.substring(startIndex);
    let rowRegex = /[a-zA-Z]/g;
    if (rowRegex.test(row) || parseInt(row, 10) < 1 || parseInt(row, 10) > 1048576) return false;

    // check for illegal characters
    let charRegex = /^[a-zA-Z0-9_.-]*$/;
    if (!charRegex.test(coordinate)) return false;

    return true;
  }

  async downloadPreviewExport() {
    let tempSavedTemplate = false;
    if (this._templateBlob && !this._itemData.export_template_key) {
      await this.saveTemplate();
      tempSavedTemplate = true;
    }
    await import('../katapult-maps-desktop/exports/excel-exports.js');

    // check to see that the proper data is setup for the preview download
    let errorMessage = '';
    if (!this._itemData.export_file_type || !this._itemData.preview_job) {
      if (!this._itemData.export_file_type) errorMessage += '\r\n - File Type not set';
      if (!this._itemData.preview_job) errorMessage += '\r\n - Preview job not selected';
    }

    // check to see that all of the cell references are correctly entered
    let cellInputs = this.shadowRoot.querySelectorAll('.locationInput');
    for (let i = 0; i < cellInputs.length; i++) {
      let valid = this.validateCellReference(cellInputs[i].value);
      if (!valid) errorMessage += `\r\n - Invalid Cell Address (${cellInputs[i].value})`;
    }

    if (errorMessage) throw Error(errorMessage);

    // call excel exports runExport function
    await this.$.excelExports.runExport(
      'configurableExportDownload',
      async (fileData) => {
        // Create a blob from the file data
        let fileBlob = new Blob([fileData.data], {
          type: fileData.mimeType
        });
        let url = URL.createObjectURL(fileBlob);
        var a = document.createElement('a');
        a.href = url;
        a.download = KLogic.compute(this._itemData.file_name, this.computeData);
        document.body.appendChild(a);
        a.click();

        if (tempSavedTemplate) {
          await firebase.storage().ref(`model_space_files/${this.modelSpaceDetails.$key}/${this._itemData.export_template_key}`).delete();
          this.set('_itemData.export_template_key', null);
        }
      },
      { exportData: this._itemData, computeData: this.computeData }
    );
  }

  async beforeSave() {
    await this.saveTemplate();
  }

  async beforeDelete() {
    await this.saveTemplate({ forceDelete: true });
  }

  async promptLoadTemplate(e) {
    const button = e.currentTarget;
    const input = button.parentElement.querySelector('#input');
    input.click();
  }

  async loadTemplate(e) {
    const input = e.currentTarget;
    const file = input.files[0];
    input.value = null;
    if (!file) return;
    this.set('_templateBlob', file);
    this.set('_itemData.export_template_name', file.name);
  }

  removeTemplate() {
    this.set('_templateBlob', null);
    this.set('_itemData.export_template_name', null);
  }

  async saveTemplate({ forceDelete = false } = {}) {
    const storageRef = firebase.storage().ref(`model_space_files/${this.modelSpaceDetails.$key}`);

    const currentStorageKey = this._itemData?.export_template_key;

    const handleDeleteError = (err) => {
      if (err.code != 'storage/object-not-found') throw err;
    };

    const blob = this._templateBlob;
    if (blob && !forceDelete) {
      const newStorageKey = currentStorageKey ?? uuidv4();
      await storageRef.child(newStorageKey).put(blob);
      this.set('_itemData.export_template_key', newStorageKey);
    } else if (currentStorageKey) {
      await storageRef.child(currentStorageKey).delete().catch(handleDeleteError);
      this.set('_itemData.export_template_key', null);
    }

    // Delete any keys that are no longer current.
    const firebaseStorageKey = this.itemData?.export_template_key;
    const initialStorageKey = this.itemDataReference?.export_template_key;
    for (const key of [firebaseStorageKey, initialStorageKey]) {
      if (key != null && key != currentStorageKey) await storageRef.child(key).delete().catch(handleDeleteError);
    }
  }
  async downloadTemplate() {
    let blob = this._templateBlob;
    if (!blob && this._itemData?.export_template_key) {
      this.loadingTemplateFromStorage = true;
      const url = await firebase
        .storage()
        .ref(`model_space_files/${this.modelSpaceDetails.$key}/${this._itemData?.export_template_key}`)
        .getDownloadURL();
      blob = await fetch(url)
        .then((x) => x.blob())
        .catch();
      this.loadingTemplateFromStorage = false;
    }
    if (blob) {
      Download(blob, this._itemData.export_template_name, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    }
  }
}

customElements.define('katapult-configurable-export-editor', KatapultConfigurableExportEditor);
